<div class="u-shadow-mini pos-relative">
    <app-loader [showLoader]=showLoad></app-loader>

    <div class="c-portlet_box_specs">
        <div
            class="c-portlet__header o-stack o-stack--center o-stack--splitted u-border-bottom u-px-small u-py-mini c-portlet-gap">
            <div class="o-stack__cell">
                <h5>{{sectiontitle}}</h5>
                <span *ngIf="hasData">
                    <a href="javascript:void(0)" class="datatable_download_icon" (click)="downloadCSV()" target="_blank"
                        *ngIf="downloadConfiguration && downloadConfiguration.enableDownload">
                        <img class="downloadIcon" src="../../../../../assets/images/Download_Icon.svg" />
                    </a>
                </span>
            </div>
        </div>
        <div class="analytics-portlet-content sem_calls">
            <div *ngIf="!hasData" class="no-calls-data-container">
                <div class="no-data-text no-data-text-quick-stat">No Data Available</div>
            </div>
            <div *ngIf="hasData">
                <div class="calls-data" [ngClass]="metricsData ?'noCalls-div':''">
                    <div class="call-metrics">
                        <div class="item">
                            <div class="table-text">Avg. Duration (HH:MM:SS)</div>
                            <div class="data">{{metricsData.avgDuration}}</div>
                        </div>
                        <div class="item">
                            <div class="table-text">TOTAL ANSWERED CALLS</div>
                            <div class="data">{{metricsData.answeredCalls | number}}</div>
                        </div>
                        <div class="item">
                            <div class="table-text">TOTAL MISSED CALLS</div>
                            <div class="data">{{metricsData.missedCalls | number}}</div>
                        </div>
                    </div>
                </div>
                <div class="graph-filter">
                    <div class="filterLabel" [ngClass]="{'answered-inactive': graphFilterDisabled}">
                        <span>Filter Answered Calls:</span>
                    </div>
                    <div [ngClass]="{'graph-filter-option': true, 'answered-inactive': graphFilterDisabled}">
                        <div *ngFor="let graphFilterOption of graphFilterOptions">
                            <label class="container">
                                <input type="radio" name="graphFilterOption" value="{{graphFilterOption.id}}"
                                    [(ngModel)]="selectedValue" (change)="filterChange($event)"
                                    [disabled]="graphFilterDisabled">
                                <span
                                    [ngClass]="['radio-option-text', graphFilterDisabled ? 'answered-inactive' : '', selectedValue == graphFilterOption.id ? '':'unselected-radio']">{{graphFilterOption.name}}</span>
                                <span
                                    [ngClass]="['radiocheck', graphFilterDisabled?'answered-inactive':'', ((selectedValue == graphFilterOption.id)) ? 'radioChecked' : '']"></span>
                            </label>
                        </div>
                    </div>
                </div>
                <div class="calls-graph-area">
                    <div id="chart" #graphArea></div>
                </div>
            </div>
        </div>
    </div>
</div>